import { onMounted } from 'vue'
import { onLCP, onTTFB } from 'web-vitals'
import { onCLS, onINP } from 'web-vitals/attribution'

import { useLoggerStore } from '@/store/logger'
import { getElementXPath } from '@/utils/get-element-xpath'

function getViewportString(): string {
    const width = Math.round(window.visualViewport?.width ?? window.innerWidth)
    const height = Math.round(window.visualViewport?.height ?? window.innerHeight)
    const dpr = window.devicePixelRatio || 1
    const dprStr = Number.isFinite(dpr) ? dpr.toFixed(2).replace(/\.00$/, '') : '1'
    return `${width}x${height}@${dprStr}`
}

function round(value: number): number {
    return Math.round(value)
}

function getInpTiming(inputDelay: number, processingDuration: number, presentationDelay: number): string {
    return `input:${round(inputDelay)},processing:${round(processingDuration)},presentation:${round(presentationDelay)}`
}

export function useBrowserRumTracking(): void {
    const loggerStore = useLoggerStore()

    onMounted(() => {
        onCLS((metric) => {
            loggerStore.logEvent(
                {
                    event: 'custom_event',
                    eventName: 'page_cls',
                    dimension1: metric.value.toFixed(4),
                    dimension2: getViewportString(),
                    dimension3: metric.attribution.largestShiftTarget,
                },
                { flushImmediately: true },
            )
        })

        onINP((metric) => {
            loggerStore.logEvent(
                {
                    event: 'custom_event',
                    eventName: 'page_inp',
                    dimension1: String(Math.round(metric.value)),
                    dimension2: metric.attribution.interactionTarget,
                    dimension3: getInpTiming(
                        metric.attribution.inputDelay,
                        metric.attribution.processingDuration,
                        metric.attribution.presentationDelay,
                    ),
                },
                { flushImmediately: true },
            )
        })

        onTTFB((metric) => {
            loggerStore.logEvent({
                event: 'custom_event',
                eventName: 'page_ttfb',
                dimension1: String(Math.round(metric.value)),
            })
        })

        onLCP((metric) => {
            loggerStore.logEvent(
                {
                    event: 'custom_event',
                    eventName: 'page_lcp',
                    dimension1: String(Math.round(metric.value)),
                    dimension2: getElementXPath(metric.entries.at(-1)?.element),
                },
                { flushImmediately: true },
            )
        })
    })
}
